import { useState } from "react";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import {
  ArrowLeftRight,
  Banknote,
  ChartNoAxesCombined,
  CircleAlert,
  FlaskConical,
  ReceiptText,
  UsersRound,
} from "lucide-react";
import RevenueReport from "./RevenueReport";
import InvoiceReport from "./InvoiceReports";
import TenantRegistrationReport from "./TenantRegistrationReport";
import TrialReports from "./TrialReports";
import TransactionReport from "./TransactionReport";
import FailedTransactionReport from "./FailedTransactionReport";
import ProductPerformanceReport from "./ProductPerformanceReport";
import "./Reports.css";

const reports = [
  {
    key: "tenant",
    label: "Tenant Registration",
    description: "Registration volume and active tenant health",
    icon: UsersRound,
    component: <TenantRegistrationReport />,
  },
  {
    key: "revenue",
    label: "Revenue Report",
    description: "Revenue movement across portals and statuses",
    icon: Banknote,
    component: <RevenueReport />,
  },
  {
    key: "invoice",
    label: "Invoice Report",
    description: "Invoice totals, payment state, and product mix",
    icon: ReceiptText,
    component: <InvoiceReport />,
  },
  {
    key: "trial",
    label: "Trial Report",
    description: "Trial adoption, expiry, and tenant activity",
    icon: FlaskConical,
    component: <TrialReports />,
  },
  {
    key: "transaction",
    label: "Transaction Report",
    description: "Transaction volume and portal performance",
    icon: ArrowLeftRight,
    component: <TransactionReport />,
  },
  {
    key: "failedTransaction",
    label: "Failed Transaction Report",
    description: "Failure volume, value, and portal trends",
    icon: CircleAlert,
    component: <FailedTransactionReport />,
  },
  {
    key: "productPerformance",
    label: "Product Performance Report",
    description: "Product revenue and tenant distribution",
    icon: ChartNoAxesCombined,
    component: <ProductPerformanceReport />,
  },
];

const ReportsSection = () => {
  const [activeReport, setActiveReport] = useState(reports[0].key);
  const selectedReport =
    reports.find((report) => report.key === activeReport) || reports[0];

  return (
    <main className="reports-page">
      <BreadcrumbsComponent />

      <section className="reports-nav" aria-labelledby="reports-heading">
        <div className="reports-nav-heading">
          <div>
            <h1 id="reports-heading">Reports</h1>
            <p>{selectedReport.description}</p>
          </div>
          <span className="reports-count">{reports.length} report views</span>
        </div>

        <div className="reports-tabs" role="tablist" aria-label="Report views">
          {reports.map((report) => {
            const Icon = report.icon;
            const isActive = activeReport === report.key;

            return (
              <button
                key={report.key}
                type="button"
                role="tab"
                aria-selected={isActive}
                aria-controls="active-report-panel"
                className={`reports-tab ${isActive ? "is-active" : ""}`}
                onClick={() => setActiveReport(report.key)}
              >
                <Icon size={16} aria-hidden="true" />
                <span>{report.label}</span>
              </button>
            );
          })}
        </div>
      </section>

      <section
        id="active-report-panel"
        className="report-content"
        role="tabpanel"
        aria-labelledby="reports-heading"
      >
        {selectedReport.component}
      </section>
    </main>
  );
};

export default ReportsSection;
